import * as React from 'react';
import cx from 'classnames';

export interface RadioButtonProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
  disabled?: boolean;
  className?: string;
  children?: React.ReactNode;
}

const RadioButton = ({
  label,
  children,
  className,
  disabled = false,
  size = 'md',
  ...props
}: RadioButtonProps) => {
  const radioRef = React.useRef<HTMLInputElement | null>(null);

  return (
    <label
      className={cx('t-radio', {
        [className]: !!className,
        [size]: !!size,
      })}
    >
      <input type="radio" ref={radioRef} {...props} disabled={disabled} />
      {label ? (
        <span className="text-xs whitespace-nowrap">{label}</span>
      ) : (
        children && children
      )}
    </label>
  );
};

export default RadioButton;
